import React from "react";
import { useState } from "react";

import dataEn from "../../../languages/en/secondSec";
import dataTh from "../../../languages/th/secondSec";

const SecondSection = ({ language }) => {
  const data = language === "en" ? dataEn : dataTh;
  const [showSecondHalf, setShowSecondHalf] = useState(false);

  return (
    <section className="py-12 bg-white mt-24">
      <div className="max-w-screen-2xl  mx-auto px-4">
        <h2
          id="about"
          className="font-prompt font-bold text-2xl md:text-4xl text-black mb-6 text-center"
        >
          {data.title}
        </h2>
        <div className="font-prompt text-sm text-primary-100 mb-6  w-9/12 mx-auto text-center">
          {data.desc1} <br /> {data.desc2} <br />
          {showSecondHalf && data.hiddenDesc}
        </div>

        <div className="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="40"
            viewBox="0 0 64 40"
            fill="none"
            onClick={() => setShowSecondHalf(!showSecondHalf)}
          >
            <path
              d="M15.9093 12.5C13.925 12.5 13.1519 15.078 14.8087 16.1699L30.8994 26.7746C31.5672 27.2147 32.4329 27.2147 33.1006 26.7746L49.1913 16.1699C50.8481 15.078 50.075 12.5 48.0907 12.5H15.9093Z"
              fill="#1E1E1E"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default SecondSection;
